module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '任务设置'
    }
  }, [_c('div', {
    staticClass: "tab-title"
  }, [_c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("任务类型")]), _vm._v(" "), _c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("接收时间")]), _vm._v(" "), _c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("审核条件")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "tab-main",
    class: {
      active: _vm.activeIndex == 0
    }
  }, [_c('div', {
    staticClass: "btns-top"
  }, [_c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": function($event) {
        _vm.link(0)
      }
    }
  }, [_vm._v("创建")])]), _vm._v(" "), _c('div', {
    staticClass: "back-list page"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("类型名称")]), _vm._v(" "), _c('div', [_vm._v("类型说明")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main"
  }, [_vm._l((_vm.taskTpl), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(item.tpl_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(item.tpl_description))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "blue",
      on: {
        "click": function($event) {
          _vm.link(item.id)
        }
      }
    }, [_vm._v("编辑")])])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.taskTpl
    }
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-main",
    class: {
      active: _vm.activeIndex == 1
    }
  }, [_c('taskTime')], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-main",
    class: {
      active: _vm.activeIndex == 2
    }
  }, [_c('taskExam')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-06ed3488!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-taskSetting.vue
// module id = 685
// module chunks = 1